module.exports = __webpack_public_path__ + "static/media/gw.c1e88a91.svg";